// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExclamationCircleFilledSvg from "@fishx/icons-svg/es/asn/ExclamationCircleFilled";
import FishxIcon from '../components/FishxIcon';

var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleFilledSvg
  }));
};

ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
export default React.forwardRef(ExclamationCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExclamationCircleFilled.js
// module id = 2632
// module chunks = 0